module.exports = __webpack_public_path__ + "img/top1.461e97ed.png";